/* eslint-enable */
/* eslint-enable */

class AnimationRelatedNews {
	
	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleRelatedNews = this.sectionsContainer.querySelector('.related-news');
		
		if (!this.$moduleRelatedNews)
			return;
		
		this.$moduleRelatedNewsElements = this.$moduleRelatedNews.querySelectorAll('.anima');
		
		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
        gsap.set(this.$moduleRelatedNews, { opacity: 1});
        gsap.set(this.$moduleRelatedNewsElements, { yPercent: 20, opacity: 0, onComplete: () => {
			this.initAnimate();
		} });
	}

	initAnimate() {
		this.moduleRelatedNews = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleRelatedNews,
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleRelatedNewsElements, { clearProps: true });
			}
        });
    
        this.moduleRelatedNews.addLabel('step1');
        this.moduleRelatedNews.to(this.$moduleRelatedNews, { opacity: 1, duration: 1 }, 'step1');
		this.moduleRelatedNews.to(this.$moduleRelatedNewsElements, { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default AnimationRelatedNews;